import React, { useState } from 'react';

function ProblemPage({ onSubmit, onComplete, questions }) {
  const [answers, setAnswers] = useState(Array(questions.length).fill(null));

  const handleOptionChange = (questionIndex, optionIndex) => {
    const newAnswers = [...answers];
    newAnswers[questionIndex] = optionIndex;
    setAnswers(newAnswers);

    if (newAnswers.every(answer => answer !== null)) {
      onComplete(newAnswers); // 全ての質問に回答されたら、onCompleteを呼び出す
    }
  };

  return (
    <div className="flex flex-col items-center h-screen overflow-auto">
      <div className="bg-white border border-gray-300 p-4 max-w-3xl w-full mb-4">
        <h1 className="text-2xl text-gray-800 font-bold m-2">Quiz</h1>
        {questions.map((question, questionIndex) => (
          <div key={questionIndex} className="mb-4">
            <p className="text-gray-800">{question.question}</p>
            <div className="flex flex-col">
              {question.choices.map((option, optionIndex) => (
                <label key={optionIndex} className="inline-flex items-center mt-2">
                  <input
                    type="radio"
                    name={`question-${questionIndex}`}
                    value={optionIndex}
                    checked={answers[questionIndex] === optionIndex}
                    onChange={() => handleOptionChange(questionIndex, optionIndex)}
                    className="form-radio h-4 w-4 text-blue-600"
                  />
                  <span className="ml-2">{option}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProblemPage;
